export default "__VITE_ASSET__Cdnzr8Z8__"